function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 26 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_140_5)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.262 3.052c.767-1.347 2.709-1.347 3.476 0l5.993 10.525c.759 1.334-.204 2.99-1.738 2.99H7.007c-1.534 0-2.497-1.656-1.738-2.99l5.993-10.525z",
  fill: "#F6335D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13 6.783v3.768",
  stroke: "#12002D",
  strokeWidth: "2",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "13",
  cy: "13.378",
  r: ".929",
  fill: "#12002D"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_140_5",
  x: "1.004",
  y: "2.042",
  width: "23.992",
  height: "22.525",
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: "0",
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: "4"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: "2"
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_140_5"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_140_5",
  result: "shape"
})))));